import React from 'react';

import { Select } from '../../WidgetConfiguratorComponents/FormGroups';
import chartJsStyles from './chartjsStyles';

interface LineStyleFormGroupProps {
    value: string;
    onChange: (newValue: string) => void;
}

export const LineStyleFormGroup = ({ value, onChange }: LineStyleFormGroupProps) => (
    <Select label='Line style' value={value} values={chartJsStyles.filter((a) => !a.deprecated).map(({ type }) => type)} onChange={onChange} />
);
